import { useContext, Dispatch } from 'react';
import { StatusBoardAction, StatusBoardState } from '../types';
import { StatusBoardContext } from '../contexts';

export function useStatusBoardContext(): { state:StatusBoardState, dispatch: Dispatch<StatusBoardAction>} {
  const {state, dispatch} = useContext(StatusBoardContext);
  return {state, dispatch};
}
